import { render, staticRenderFns } from "./item-banner.vue?vue&type=template&id=d2922546&"
import script from "./item-banner.vue?vue&type=script&lang=js&"
export * from "./item-banner.vue?vue&type=script&lang=js&"
import style0 from "./item-banner.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2922546')) {
      api.createRecord('d2922546', component.options)
    } else {
      api.reload('d2922546', component.options)
    }
    module.hot.accept("./item-banner.vue?vue&type=template&id=d2922546&", function () {
      api.rerender('d2922546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/item-banner/item-banner.vue"
export default component.exports